<script>
import { mapState } from 'vuex'
import cookieStorage from '@/plugins/cookieStorage.js'

import FilledButton from '@/components/element/buttons/Filled.vue'

import { COOKIE_NAMES } from '@/configs/constants'

const DELAY_BEFORE_SHOW = 3000
const DO_NOT_SHOW_WINDOW_DAYS = 31

export default {
  name: 'CookiesWindow',

  components: {
    FilledButton
  },

  data() {
    return {
      isReady: false,
      readyTimer: null
    }
  },

  computed: {
    ...mapState({
      currentCity: state => state.city.currentCity
    }),

    privacyRouteParams() {
      const { confidentiality_slug, config_confidentiality_id } = this.currentCity?.configs || {}

      if (!confidentiality_slug && !config_confidentiality_id) {
        return null
      }

      const anchorHash = '#cookies'

      return confidentiality_slug ?
        { name: 'pages:article:slug', params: { slug: this.currentCity.configs.confidentiality_slug }, hash: anchorHash } :
        { name: 'pages:article', params: { id: this.currentCity.configs.config_confidentiality_id }, hash: anchorHash }
    },

    isShow() {
      return this.isReady && !cookieStorage.getItem(COOKIE_NAMES.hasCookiesProcessingAgree)
    }
  },

  mounted() {
    this.readyTimer = setTimeout(() => {
      this.isReady = true
    }, DELAY_BEFORE_SHOW)
  },

  methods: {
    handleAgreeButtonClick() {
      cookieStorage.setItem(COOKIE_NAMES.hasCookiesProcessingAgree, true, DO_NOT_SHOW_WINDOW_DAYS)
      this.isReady = false
    }
  }
}
</script>

<template>
  <Transition name="slide-fade">
    <div v-if="isShow" class="cookies-window">
      <div class="description">
        Мы используем файлы cookie, чтобы улучшить работу сайта.

        <router-link
          v-if="privacyRouteParams"
          :to="privacyRouteParams"
          target="_blank"
          class="privacy-link"
        >
          Как это работает
        </router-link>

        <div class="bottom-section">
          <filled-button
            class="submit-button"
            type="submit"
            :disabled="isDisabledSubmit"
            @click="handleAgreeButtonClick"
          >
            Понятно
          </filled-button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<style lang="scss" scoped>
  .cookies-window {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 1000;
    width: 100%;
    max-width: 500px;
    border-radius: 20px;
    background: #F8F6F3;
    padding: 30px;
    border: 1px solid #e6e6e6;
    box-shadow: 0px 2px 6px rgb(0 0 0 / 21%);

    .description {
      font-size: 18px;
      line-height: 22px;
      color: #808183;
    }

    .bottom-section {
      margin-top: 30px;
      display: flex;
      justify-content: center;
    }

    .privacy-link {
      color: #9a2b0b;
      text-decoration: underline;
    }

    @media screen and (max-width: 568px) {
      bottom: 0;
      right: initial;
      left: 0;
      max-width: initial;
      border-radius: 20px 20px 0 0;
    }
  }

  .slide-fade-enter-active {
    transition: all 0.3s ease-out;
  }

  .slide-fade-leave-active {
    transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
  }

  .slide-fade-enter-from,
  .slide-fade-leave-to {
    transform: translateY(20px);
    opacity: 0;
  }
</style>
